module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-4-pod_600px_width-0_1-@3x.732f6e35.png";